import { useMutation } from "@tanstack/react-query";
import { findContentSnippets } from "../../../api/articles";
import { logAxiosError } from "../../../logging/logSentryError";

export const getFindContentSnippetsMutation = () => useMutation({
    mutationFn: findContentSnippets,
    onError: logAxiosError
});